<template>
  <v-app-bar app class="menu-bg-gradinte-iph-red">
    <!-- Button with Function that whating state of the menu drauer - True or False -->
    <v-app-bar-nav-icon class="title white--text" @click.close="ActionSetDrawer"></v-app-bar-nav-icon>
    <!-- Logo of App -->
    <!-- <v-img class="mr-4" src="../../../assets/images/layout/logo-sys.png" style="max-width: 36px;"></v-img> -->
    <!-- Slogan of App -->
      <v-toolbar-title class="mr-12 align-center">
      <span class="white--text">Instituto Pró-Hemoce - Sistema Administrativo </span>
      </v-toolbar-title>
      <!-- Space between Slogan and Logout Component -->
      <v-spacer></v-spacer>
      <!-- Component Logout -->
      <!-- <Logout /> -->
  </v-app-bar>
</template>
<script>
// import Logout from './Logout'
import { mapActions } from 'vuex'

export default {
  name: 'MainNavbar',
  // components: {
  //     Logout
  // },
  methods: {
    ...mapActions('menu', ['ActionSetDrawer']),
  },
}
</script>